import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Label } from 'src/app/models/label.model';
import { LabelService } from 'src/app/services/apis/labels.service';
import { AuthService } from 'src/app/services/auth.service';
import { concatMap, from } from 'rxjs';
import { LoadLabels, LoadLabelsSuccess } from '../actions/labels.actions';

export interface LabelStateModel {
  labels: Label[];
  labelsLoaded: boolean;
}

@State<LabelStateModel>({
  name: 'labels',
  defaults: {
    labels: [],
    labelsLoaded: false,
  },
})
@Injectable()
export class LabelState {
  constructor(
    private labelService: LabelService,
    private authService: AuthService
  ) {}

  // Selectors
  @Selector()
  static getLabels(state: LabelStateModel): Label[] {
    return state.labels;
  }

  @Selector()
  static areLabelsLoaded(state: LabelStateModel): boolean {
    return state.labelsLoaded;
  }

  // Actions
  @Action(LoadLabels)
  loadLabels(ctx: StateContext<LabelStateModel>, action: LoadLabels) {
    return this.labelService.getLabels(action.langIso).pipe(
      concatMap((labelsList) => ctx.dispatch(new LoadLabelsSuccess(labelsList)))
    );
  }


  @Action(LoadLabelsSuccess)
  loadLabelsSuccess(
    ctx: StateContext<LabelStateModel>,
    action: LoadLabelsSuccess
  ) {
    ctx.patchState({
      labels: action.labelsList,
      labelsLoaded: true,
    });
  }
}
